// extracted by mini-css-extract-plugin
export default {"Wrapper":"ContractsActions_Wrapper__SnspN"};